import React from 'react';
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  TextField,
  RadioGroup,
  Radio,
} from '@mui/material';

const StaffPresentBehaviorSection = ({
  dataPoint,
  index,
  handleCheckboxChange,
  handleFieldChange,
  shouldShowOption,
}) => {
  const preventNumberScroll = (event) => {
    event.preventDefault();
    event.target.blur();
  };

  if (!shouldShowOption('Add Staff Present Information')) {
    return null;
  }

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={dataPoint.selectedOptions.includes(
              'Add Staff Present Information'
            )}
            onChange={(e) => handleCheckboxChange(index, e)}
            value='Add Staff Present Information'
          />
        }
        label='Add Staff Present Information'
      />
      {dataPoint.selectedOptions.includes(
        'Add Staff Present Information'
      ) && (
        <Box sx={{ ml: 3, pl: 2, borderLeft: '2px solid #e0e0e0' }}>
          <Box sx={{ gap: 2, marginTop: '10px', marginBottom: '10px' }}>
            <Typography variant='body1'>
              Were there additional staff members present?
            </Typography>
            <RadioGroup
              row
              value={dataPoint.additionalStaff ? 'yes' : 'no'}
              onChange={(e) =>
                handleFieldChange(
                  index,
                  'additionalStaff',
                  e.target.value === 'yes'
                )
              }
            >
              <FormControlLabel
                value='yes'
                control={<Radio />}
                label='Yes'
              />
              <FormControlLabel value='no' control={<Radio />} label='No' />
            </RadioGroup>
            {dataPoint.additionalStaff && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  mt: 1,
                  ml: 4,
                }}
              >
                <Typography variant='body1'>How many? </Typography>
                <TextField
                  type='number'
                  margin='dense'
                  value={dataPoint.numberOfStaffs}
                  sx={{ width: '30%', padding: '0' }}
                  onChange={(e) =>
                    handleFieldChange(
                      index,
                      'numberOfStaffs',
                      e.target.value
                    )
                  }
                  inputProps={{ onWheel: preventNumberScroll }}
                />
              </Box>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

export default StaffPresentBehaviorSection;
